<template>
  <layout-default>
    <vue-headful
      title="Até o Futuro - ⚔⚡ Agende sua mentoria"
      description="Agende sua mentoria gratuita"
    />
    <div class="box">
      <h1 class="title is-3">📅 Agende sua mentoria</h1>
      <h2 class="subtitle is-3">Fale com a gente para uma mentoria personalizada</h2>

      <div class="columns">
        <div class="column is-6">
          <h3 class="subtitle is-3">
            <b-icon icon="account" size="large" /> Seus dados
          </h3>

          <b-field label="Nome" label-position="on-border">
            <b-input
              v-model="name"
              placeholder="Seu nome Aqui"
              :message="nameErrorMessage"
              :type="nameErrorMessage ? 'is-danger' : ''"
            ></b-input>
          </b-field>

          <b-field
            label="Email"
            label-position="on-border"
            :type="emailErrorMessage ? 'is-danger' : ''"
          >
            <b-input
              type="email"
              placeholder="seuEmail@provedor.com"
              v-model="email"
              icon="email"
              maxlength="150"
              :message="emailErrorMessage"
            >
            </b-input>
          </b-field>

          <b-field label="Informações adicionais" label-position="on-border">
            <b-input maxlength="200" type="textarea" v-model="infoAdicional"></b-input>
          </b-field>

          <b-field label="WhatsApp para Notificações (opcional)" label-position="on-border">
            <b-input
              placeholder="+5511XXXXX-XXXX"
              type="phone"
              icon="phone"
              v-cleave="masks.phone"
              v-model="whatsAppNumber"
            ></b-input>
          </b-field>

          <b-field label="URL do seu Curriculum ou Linkedin (opcional)" label-position="on-border">
            <b-input
              v-model="linkedInURL"
              expanded
              icon="linkedin"
              placeholder="Como podemos te conhecer melhor"
            ></b-input>
          </b-field>

          <br />
          <b-checkbox
            size="is-small"
            type="is-success"
            v-model="consentimentoPrivacidade"
            native-value="Concordo com os termos de privacidade"
          >
            Eu concordo com os usos de meus dados pessoais somente para
            finalidade da mentoria, podendo pedir a eliminação dos meus dados a qualquer momento.
            <router-link :to="{ name: 'Privacidade' }">Política de Privacidade</router-link>
          </b-checkbox>

          <br /><br />
          <b-button size="is-large" :disabled="!consentimentoPrivacidade" type="is-success" @click="save()">Agendar Mentoria ⚡</b-button>
        </div>

        <div class="column is-6">
          <div class="box">
            <h2 class="subtitle is-3">🚀 Como funciona?</h2>
            <p>Registre sua solicitação e nossa equipe vai propor datas e combinar a mentoria com você.</p>
            <br />
            <video autoplay muted loop id="myVideo">
              <source src="@/assets/Empregabilidade.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>


<script>
import firebase from "firebase";
require("cleave.js/dist/addons/cleave-phone.br");
import Cleave from "cleave.js";

const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    if (input && input._vCleave) input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },
  data() {
    return {
      whatsAppNumber: null,
      linkedInURL: null,
      name: null,
      email: null,
      infoAdicional: null,
      consentimentoPrivacidade: false,
      masks: {
        phone: {
          phone: true,
          phoneRegionCode: "BR",
        },
      },
    };
  },
  mounted() {
    if (this.$store.state.currentUser != null) {
      this.name = this.$store.state.currentUser.displayName;
      this.email = this.$store.state.currentUser.email;
      this.linkedInURL = this.$store.state.currentUserLinkedInURL;
    }
  },
  computed: {
    emailErrorMessage() {
      if (this.email == null || this.email == "") {
        return "E-mail inválido";
      }
      return null;
    },
    whatsAppErrorMessage() {
      if (this.whatsAppNumber == null || this.whatsAppNumber == "") {
        return "Telefone inválido";
      }
      return null;
    },
    nameErrorMessage() {
      if (this.name == null || this.name == "") return "Informe seu nome, por favor";
      return null;
    },
  },
  methods: {
    save() {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var isValidEmail = this.email != null && re.test(String(this.email).toLowerCase());
      var isValidWhatsApp = this.whatsAppNumber != null && this.whatsAppNumber.replace(/\s/g, "").length >= 8;

      if (
        this.nameErrorMessage != null ||
        (this.emailErrorMessage != null && this.whatsAppErrorMessage != null)
      ) {
        this.$buefy.dialog.alert({
          message: "😢 Ops! Precisamos pelo menos de seu nome e de uma informação de contato (e-mail ou whatsapp)",
          onConfirm: () => {
            this.$buefy.toast.open(`Preencha todos os campos para entrar em contato`);
          },
        });
        return;
      }

      if (this.email != null && this.email != "" && !isValidEmail) {
        this.$buefy.dialog.alert({
          message: "😢 Ops! Parece que esse e-mail não está legal.",
          onConfirm: () => {
            this.$buefy.toast.open(`Ops! E-mail inválido`);
          },
        });
        return;
      }

      if (this.whatsAppNumber != null && !isValidWhatsApp) {
        this.$buefy.dialog.alert({
          message: "😢 Ops! Parece que seu número do WhatsApp não está completo.",
          onConfirm: () => {
            this.$buefy.toast.open(`Ops! Whats App não parece certo!`);
          },
        });
        return;
      }

      if (!this.consentimentoPrivacidade) {
        this.$buefy.dialog.alert({
          message: "🔒 Para prosseguir, por favor aceite a política de privacidade.",
        });
        return;
      }

      // Generate a new key then write under /MentoringRequests
      const newRef = firebase.database().ref('/MentoringRequests').push();
      const newMentoringRequestID = newRef.key;

      var LoggedUserId = null;
      var LoggedUserName = null;
      var LoggedCreatedByUserEmail = null;

      if (this.$store.state.currentUser) {
        LoggedUserId = this.$store.state.currentUser.uid;
        LoggedUserName = this.$store.state.currentUser.displayName;
        LoggedCreatedByUserEmail = this.$store.state.currentUser.email;
      }

      const payload = {
        LoggedUserId: LoggedUserId,
        LoggedUserName: LoggedUserName,
        LoggedCreatedByUserEmail: LoggedCreatedByUserEmail,
        Name: this.name,
        Email: this.email,
        WhatsApp: this.whatsAppNumber,
        linkedInURL: this.linkedInURL,
        infoAdicional: this.infoAdicional,
        consentimentoPrivacidade: this.consentimentoPrivacidade,
        CreatedAt: firebase.database.ServerValue.TIMESTAMP,
        id: newMentoringRequestID,
      };

      newRef
        .update(payload)
        .then(() => {
          this.$buefy.dialog.alert({
            message: `Obrigado! Sua solicitação de mentoria foi registrada. Em breve entraremos em contato.`,
            onConfirm: () => {
              this.$router.replace({ name: 'Sobre' });
            },
          });
        })
        .catch((err) => {
          console.error(err);
          this.$buefy.dialog.alert({ message: `Erro ao salvar: ${err.message || err}` });
        });
    },
  },
};
</script>
